import styled from "styled-components";
import { Link } from "react-router-dom";
import CopyIcon from "shared-components/icons/copy-icon";

import {
  BLACK_COLOR,
  AMBER_COLOR,
  GREEN_TAG_FONT_COLOR,
} from "constants/style/color";

export const UserRoute = styled(Link)`
  color: ${BLACK_COLOR};
`;

export const CopyIconLogo = styled(CopyIcon)`
  margin: 6px;
  cursor: pointer;
`;

export const DispatchStatusText = styled.span<{ $status: string }>`
  color: ${({ $status }) =>
    $status === "saved"
      ? AMBER_COLOR
      : $status === "sent"
      ? GREEN_TAG_FONT_COLOR
      : BLACK_COLOR};
  text-transform: capitalize;
`;
